import T from 'Components/Helpers/translate';

/**
 * "Account manager: Anna, Bo" for a CRM company's meta line (WEB-13771): a group's companies often
 * share one name, and who owns each is what tells them apart. Null when it has none.
 */
export const accountManagerMeta = (names: string[] | undefined): string | null =>
	names?.length ? `${T('default.accountManager')}: ${names.join(', ')}` : null;
